import { Combobox, Listbox, Tag, AutoSelection, Text, VerticalStack, LegacyStack } from '@shopify/polaris';
import { useState, useCallback, useMemo, useEffect } from 'react';

const InputSelectorMultiple = ({ label, validOptions, selected, onChange }) => {
  const deselectedOptions = useMemo(() => validOptions, [validOptions]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(deselectedOptions);
  const escapeSpecialRegExCharacters = useCallback((value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), []);

  const updateText = useCallback(
    (value) => {
      setInputValue(value);

      if (value === '') {
        setOptions(deselectedOptions);
        return;
      }

      const filterRegex = new RegExp(escapeSpecialRegExCharacters(value), 'i');
      const resultOptions = deselectedOptions.filter((option) => option.label.match(filterRegex));
      setOptions(resultOptions);
    },
    [deselectedOptions, escapeSpecialRegExCharacters],
  );

  const updateSelection = useCallback(
    (selected) => {
      setSelectedOptions(
        selectedOptions.includes(selected)
          ? selectedOptions.filter((option) => option !== selected)
          : [...selectedOptions, selected],
      );

      updateText('');
    },
    [selectedOptions, updateText],
  );

  useEffect(() => {
    onChange(selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  const removeTag = useCallback(
    (tag) => () => {
      const options = [...selectedOptions];
      options.splice(options.indexOf(tag), 1);
      setSelectedOptions(options);
    },
    [selectedOptions],
  );

  const optionsMarkup =
    options.length > 0
      ? options.map((option) => {
          const { label, value } = option;

          return (
            <Listbox.Option
              key={`${value}`}
              value={value}
              selected={selectedOptions.includes(value)}
              accessibilityLabel={label}
            >
              {label}
            </Listbox.Option>
          );
        })
      : null;

  const tagsMarkup = selectedOptions.map((option) => (
    <Tag key={`option-${option}`} onRemove={removeTag(option)}>
      {option}
    </Tag>
  ));

  const verticalContentMarkup = (
    <LegacyStack spacing="extraTight" alignment="center">
      <Text>{label}</Text>
      {selectedOptions.length > 0 && tagsMarkup}
    </LegacyStack>
  );

  return (
    <VerticalStack gap={1}>
      <Combobox
        allowMultiple
        activator={
          <Combobox.TextField
            onChange={updateText}
            label={label}
            labelHidden
            value={inputValue}
            // suggestion={suggestion}
            // placeholder={label}
            verticalContent={verticalContentMarkup}
            autoComplete="off"
          />
        }
      >
        {optionsMarkup ? (
          <Listbox autoSelection={AutoSelection.None} onSelect={updateSelection}>
            {optionsMarkup}
          </Listbox>
        ) : null}
      </Combobox>
    </VerticalStack>
  );
};

export default InputSelectorMultiple;
